import urls from '../api_urls/aboutBASF'
import { _post } from '@/axios/request'
// 获取关于BASF列表
export function getTableData (params) {
    return _post(urls.GET_LIST, params)
}
// 新增关于BASF
export function saveAboutBASF (params) {
    return _post(urls.ADD_ABOUT_BASF, params)
}
// 新增关于BASF
export function editAboutBASF (params) {
    return _post(urls.EDIT_ABOUT_BASF, params)
}
// 获取关于BASF详情
export function getDetail (params) {
    return _post(urls.GET_DETAIL, params)
}
// 校验邮箱
export function checkEmailApi (params) {
    return _post(urls.CHECK_EMAIL, params)
}
// 校验权重
export function checkWeight (params) {
    return _post(urls.CHECK_WEIGHT, params)
}
export function updateHiddenApi (params) {
    return _post(urls.UPDATE_HIDDEN, params)
}



// WEBPACK FOOTER //
// ./src/axios/api/aboutBASF.js